import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "./store";

interface CrossMerchantState {
  merchantMapping: Record<string, string | number>;
  liquidityProvidersMapping: Record<string, string>;
}

const initialState: CrossMerchantState = {
  merchantMapping: {},
  liquidityProvidersMapping: {},
};

const crossMerchantSlice = createSlice({
  name: "crossMerchant",
  initialState,
  reducers: {
    setMerchantMapping: (
      state,
      action: PayloadAction<{ id: string; name: string }[]>
    ) => {
      state.merchantMapping = action.payload.reduce(
        (acc: Record<string, string | number>, { id, name }) => ({
          ...acc,
          [name]: Number(id),
          [id]: name,
        }),
        {}
      );
    },
    setLiquidityProvidersMapping: (
      state,
      action: PayloadAction<
        {
          merchant_id: number;
          liquidity_provider: string;
          remarks: string;
          created_date: string;
          last_modified_date: string;
        }[]
      >
    ) => {
      state.liquidityProvidersMapping = action.payload.reduce(
        (acc: Record<string, string>, { liquidity_provider }) => ({
          ...acc,
          [liquidity_provider]: liquidity_provider,
        }),
        {}
      );
    },
  },
});

export const { setMerchantMapping, setLiquidityProvidersMapping } =
  crossMerchantSlice.actions;

export const selectCrossMerchant = (state: RootState) => state.crossMerchant;

export default crossMerchantSlice.reducer;
